import React, { useEffect, useState, useRef } from 'react';
import { useDanceStore } from '../store/useDanceStore';

const JOINTS = [
  'head', 'neck', 'stomach', 'torso',
  'leftClavicle', 'leftShoulder', 'leftElbow', 'leftPalm',
  'leftHip', 'leftKnee', 'leftFoot'
];

export const UIConnections: React.FC = () => {
  const showLabels = useDanceStore(state => state.showLabels);
  const activeModule = useDanceStore(state => state.activeModule);
  const [lines, setLines] = useState<{ x1: number; y1: number; x2: number; y2: number; key: string }[]>([]);
  const requestRef = useRef<number>(0);

  const updateLines = () => {
    const newLines: typeof lines = [];
    
    JOINTS.forEach(joint => {
      const labelEl = document.getElementById(`label-${joint}`);
      const controlHeadingEl = document.getElementById(`joint-heading-${joint}`);
      const controlEl = controlHeadingEl || document.getElementById(`joint-control-${joint}`);
      
      if (labelEl && controlEl && showLabels) {
        const labelRect = labelEl.getBoundingClientRect();
        const controlRect = controlEl.getBoundingClientRect();
        
        const isCore = ['head', 'neck', 'stomach', 'torso'].includes(joint);
        
        let x1, y1, x2, y2;
        
        if (isCore) {
          // Core labels are positioned to the left of the mannequin.
          // Sidebar Core is on the Left.
          x1 = labelRect.left;
          y1 = labelRect.top + labelRect.height / 2;
          x2 = controlRect.right;
          y2 = controlRect.top + controlRect.height / 2;
        } else {
          // Individual joint labels (left-side ones) are positioned to the right of the mannequin.
          // Sidebar Joints is on the Right.
          x1 = labelRect.right;
          y1 = labelRect.top + labelRect.height / 2;
          x2 = controlRect.left;
          y2 = controlRect.top + controlRect.height / 2;
        }
        
        newLines.push({ x1, y1, x2, y2, key: joint });
      }
    });
    
    setLines(newLines);
    requestRef.current = requestAnimationFrame(updateLines);
  };

  useEffect(() => {
    if (activeModule === 'PoseDesigner' && showLabels) {
      requestRef.current = requestAnimationFrame(updateLines);
    } else {
      if (requestRef.current) cancelAnimationFrame(requestRef.current);
      setLines([]);
    }
    return () => {
      if (requestRef.current) cancelAnimationFrame(requestRef.current);
    };
  }, [showLabels, activeModule]);

  if (!showLabels || activeModule !== 'PoseDesigner') return null;

  return (
    <svg style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      zIndex: 5, // Above canvas (1), below sidebars (10)
    }}>
      {lines.map(line => (
        <line
          key={line.key}
          x1={line.x1}
          y1={line.y1}
          x2={line.x2}
          y2={line.y2}
          stroke="#fde047" // Same as label text color (Amber/Yellow)
          strokeOpacity="0.4"
          strokeWidth="1"
          strokeDasharray="2,2"
        />
      ))}
    </svg>
  );
};
